import {AfterViewInit, Component, OnInit} from '@angular/core';
import { Localiser } from "../../services/localiser";
import { UserService } from "../../services/user.service";
import {user} from "../../models/user";

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements AfterViewInit {

  nombre: string = "";
  apellidos: string = "";
  email: string = "";
  telefono: string = "";

  oldPassword: string = "";
  newPassword1: string = "";
  newPassword2: string = "";

  chargingProfile: boolean = false;
  feedbackProfile: number = 0;

  chargingPassword: boolean = false;
  feedbackPassword: number = 0;

  constructor(public localiser: Localiser, public user: UserService) { }

  ngAfterViewInit(): void {
    this.nombre = this.user.getNombre();
    this.apellidos = this.user.getApellidos();
    this.email = this.user.getEmail();
    this.telefono = this.user.getTelefono();
  }


  updateUser() {
    this.feedbackProfile = 0;
    this.chargingProfile = true;
    this.user.updateUser(this.nombre, this.apellidos, this.email, this.telefono).subscribe(result => {
      this.user.rechargeUser();
      this.feedbackProfile = 1;
      this.chargingProfile = false;
    }, error => {
      this.feedbackProfile = error.error;
      this.chargingProfile = false;
    });
  }

  updatePassword() {
    this.feedbackPassword = 0;
    if (this.oldPassword.length > 0 && this.newPassword1.length >= 8  && this.newPassword2.length >= 8
      && this.newPassword1 == this.newPassword2 && this.newPassword1.match(/[a-z]+/)
      && this.newPassword1.match(/[A-Z]+/) && this.newPassword1.match(/[0-9]+/)) {

      this.chargingPassword = true;
      this.user.updatePassword(this.oldPassword, this.newPassword1).subscribe(result => {
        this.feedbackPassword = +result;
        this.chargingPassword = false;
      }, error => {
        this.feedbackPassword = +error.error;
        this.chargingPassword = false;
        if (isNaN(this.feedbackPassword)) {
          this.feedbackPassword = -4;
        }
      });

    } else if (this.oldPassword.length <= 0 || this.newPassword1.length <= 0 || this.newPassword2.length <= 0) {
      this.feedbackPassword = -1;
    } else if (this.newPassword1 != this.newPassword2) {
      this.feedbackPassword = -2;
    } else if (this.newPassword1.length < 8 || !this.newPassword1.match(/[a-z]+/)
      || !this.newPassword1.match(/[A-Z]+/) || !this.newPassword1.match(/[0-9]+/)) {
      this.feedbackPassword = -5;
    }
  }

  whichPasswordMessage() {
    if (this.feedbackPassword == 1) {
      return this.localiser.get("profile.changePasswordDoneMessage");
    } else if (this.feedbackPassword == -1) {
      return this.localiser.get("profile.changePasswordErrorMessage1");
    } else if (this.feedbackPassword == -2) {
      return this.localiser.get("profile.changePasswordErrorMessage2");
    } else if (this.feedbackPassword == -3) {
      return this.localiser.get("profile.changePasswordErrorMessage3");
    } else if (this.feedbackPassword == -4) {
      return this.localiser.get("profile.changePasswordErrorMessage4");
    } else if (this.feedbackPassword == -5) {
      return this.localiser.get("profile.changePasswordErrorMessage5");
    }
  }

  whichProfileMessage() {
    if (this.feedbackProfile == 1) {
      return this.localiser.get("profile.changeProfileDoneMessage");
    } else if (this.feedbackProfile == -1) {
      return this.localiser.get("profile.changeProfileErrorMessage1");
    } else if (this.feedbackProfile == -2) {
      return this.localiser.get("profile.changeProfileErrorMessage2");
    }
  }

}
